
import { Component, Vue } from 'vue-property-decorator';
import PageFooter from '@/components/page-footer.vue';
import {
	dataStatisProductSellAnalysisProductRetailRankList
} from "@/api/material";
import { defaultHeader } from "@/utils/config";

@Component({
	name: '',
	components: {
		PageFooter
	}
})
export default class ProductList extends Vue {
	private defaultHeader = defaultHeader
	private keywords = '';
	private list: any = []
	private pageNo = 1;
	private pageSize = 10;
	private total = 0

	private productId = this.$route.query.id;
	private startTime:any = this.$route.query.startTime;
	private endTime:any = this.$route.query.endTime;
	private productName = this.$route.query.name;

	private mounted() {
		this.getList();
	}

	private doSearch() {
		this.pageNo = 1;
		this.getList();
	}

	private doClear() {
		this.keywords = '';
		this.pageNo = 1;
		this.getList();
	}

	// 获取列表
	private async getList() {
		let params: any = {
			Skip: (this.pageNo - 1) * this.pageSize,
			Take: this.pageSize,
			Keywords: this.keywords,
			ProductId: this.productId,
			StartDate: this.startTime,
			EndDate: this.endTime
		}
		try {
			const res: any = await dataStatisProductSellAnalysisProductRetailRankList(params);
			this.list = res.Result.Results;
			this.total = res.Result.Total;
		} catch (err) {
			console.error('getProviderStatistics ===>', err)
		}
	}

	private pageChange(num: number) {
		this.pageNo = num;
		this.getList();
	}

	private handleExport(){
		let url = location.origin + '/pc/dataStatisProductSellAnalysis/productRetailRankList';
			url += '?Keywords=' + this.keywords
			url += '&ProductId=' + (this.productId || '')
			url += '&StartDate=' + (this.startTime || '')
			url += '&EndDate=' + (this.endTime || '')
		window.open(url)
	}

}
